module.exports = __webpack_public_path__ + "img/36070-4.prt.be23b141.jpg";